export default "__VITE_ASSET__CyND1bUe__"